export default "__VITE_ASSET__7d1d00a4__"